/**
 * @typedef {number} RushRaceStatus
 */

export const RUSH_RACE_STATUS__NONE            = 0;
export const RUSH_RACE_STATUS__OPEN_FOR_JOIN   = 1;
export const RUSH_RACE_STATUS__CLOSED_FOR_JOIN = 2;

/**
* @param {RushRaceStatus} status
* @returns {string}
*/
export function getRushRaceStatusName(status) {
  switch(status) {
    case RUSH_RACE_STATUS__NONE:             return 'none';
    case RUSH_RACE_STATUS__OPEN_FOR_JOIN:    return 'open for join';
    case RUSH_RACE_STATUS__CLOSED_FOR_JOIN:  return 'closed for join';
  }
  
  return `Unknown status ${status}.`;
}

/**
 * @param {RushRaceStatus} status
 * @returns {Object}
 */
export function getRushStatusClass(status) {
  return {
    rushRaceOpenForJoin: (status === RUSH_RACE_STATUS__OPEN_FOR_JOIN),
  };
}
